/**
 * sdx-gwp.js — Hediye kampanyası (Gift With Purchase), KADEMELİ (v3.0).
 *
 * Her kademe (`gwp_config` kaydı) kendi eşiği ve hediye ürünüyle bağımsız çalışır;
 * kademeler BİRİKİR (3.500 TL'yi geçen sepet hem saşeyi hem matarayı alır).
 *
 * Görev 1 (uzlaştırıcı): Sepet her değiştiğinde tutarı ölç, her kademe için:
 *   >= eşik  -> o kademenin hediyesini sepete ekle (tam 1 adet)
 *   <  eşik  -> o kademenin hediye satırını SİL
 * Görev 2 (pop-up): Bir kademenin teşvik bandına girince bir kez bildir;
 *   bir kademe kazanılınca onay göster.
 *
 * Ayarların tamamı `gwp_config` metaobject kayıtlarından gelir (bkz.
 * snippets/sdx-gwp-config.liquid). Bu dosyada eşik/metin HARDCODE EDİLMEZ.
 *
 * ÜCRETSİZLİK NEREDEN GELİYOR: hediyelerin fiyatı GERÇEKTEN 0'dır — indirimle
 * sıfırlanmış değil. Neden (ölçüldü 2026-09-23): bu planda sepet başına BİR sipariş +
 * BİR ürün indirimi uygulanıyor. Hediye indirimle ücretsizleştirilseydi bir ÜRÜN
 * indirimi olur ve Kaching çoklu alım / "Birlikte daha iyi" / sonbahar kampanyası ile
 * aynı yuva için yarışırdı. Fiyat 0 olunca hiçbir yuva harcanmaz.
 *
 * Ölçülen tutar = cart.total_price eksi TÜM hediye satırlarının tutarı (saşe ERP
 * kısıtı nedeniyle 0,01 TL; bir hediye diğerinin eşiğini beslemesin).
 *
 * EŞİK İNDİRİMLER SONRASIDIR (2026-10-20): `tier.threshold` kasada düşen müşteri
 * indirimiyle yükseltilmiş sepet eşiğidir (sdx-gwp-config KRİTİK 5); metinlerdeki
 * {esik} panel değeri olan `tier.displayThreshold`'u gösterir.
 */
(function () {
  'use strict';

  var CFG = null;
  try {
    var node = document.getElementById('sdx-gwp-config');
    CFG = node ? JSON.parse(node.textContent) : null;
  } catch (err) {
    return;
  }
  if (!CFG || !CFG.tiers) return;

  var TIERS = CFG.tiers
    .filter(function (t) { return t && t.variantId && t.threshold > 0; })
    .sort(function (a, b) { return a.threshold - b.threshold; });
  var RETIRED = (CFG.retiredVariantIds || []).filter(Boolean);
  if (!TIERS.length && !RETIRED.length) return;

  var GIFT_IDS = TIERS.map(function (t) { return t.variantId; }).concat(RETIRED);

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  var busy = false;
  var pending = null;
  var timer = null;
  var lastState = {};

  /* ---------------------------------------------------------------- para biçimi */

  /**
   * Mağazanın money_format'ını onurlandırır. Tek istisna: mağaza TRY iken format
   * İngilizce ayraç jetonunu kullanıyorsa (1,750.00) Türkçe kardeşine yükseltilir
   * (1.750,00). Aksi halde bu kampanya metni "Hediyenize 1,234.56TL kaldı" derdi.
   */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '{{amount}}';
    var token = (fmt.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    if ((CFG.currency === 'TRY') && token === 'amount') token = 'amount_with_comma_separator';
    if ((CFG.currency === 'TRY') && token === 'amount_no_decimals') token = 'amount_no_decimals_with_comma_separator';

    var value = (cents || 0) / 100;
    var decimals = token.indexOf('no_decimals') !== -1 ? 0 : 2;
    var comma = token.indexOf('comma_separator') !== -1;
    var locale = comma ? 'tr-TR' : 'en-US';
    var out;
    try {
      out = new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(value);
    } catch (e) {
      out = value.toFixed(decimals);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /**
   * Cümle içinde kullanılacak ürün adı. Katalogdaki başlıklar "Ad | Nitelik"
   * biçiminde; tam başlık cümleye gömülünce "… | Hediye siparişinize hediye olarak
   * eklendi" gibi okunuyor. Tema bu kırpmayı sepet önerilerinde de yapıyor.
   */
  function urunAdi(tier) {
    return String(tier.productTitle || '').split('|')[0].trim();
  }

  function fill(tier, tpl, remaining) {
    return String(tpl || '')
      .replace(/\{kalan\}/g, formatMoney(remaining))
      .replace(/\{esik\}/g, formatMoney(tier.displayThreshold || tier.threshold))
      .replace(/\{urun\}/g, urunAdi(tier));
  }

  /* ------------------------------------------------------------------- sepet ölçümü */

  function linesOf(cart, variantId) {
    return (cart.items || []).filter(function (i) { return i.variant_id === variantId; });
  }

  function eligibleTotal(cart) {
    var own = (cart.items || []).reduce(function (s, i) {
      return GIFT_IDS.indexOf(i.variant_id) !== -1 ? s + (i.final_line_price || 0) : s;
    }, 0);
    return Math.max(0, (cart.total_price || 0) - own);
  }

  /* --------------------------------------------------------------------- oturum izi */

  function seen(key) {
    try { return sessionStorage.getItem('sdx_gwp_' + key) === '1'; } catch (e) { return false; }
  }
  function mark(key) {
    try { sessionStorage.setItem('sdx_gwp_' + key, '1'); } catch (e) { /* özel sekme */ }
  }
  function unmark(key) {
    try { sessionStorage.removeItem('sdx_gwp_' + key); } catch (e) { /* özel sekme */ }
  }

  /* ------------------------------------------------------------------ uzlaştırma */

  /**
   * Hediye SdxCart.add ile DEĞİL, doğrudan /cart/add.js ile eklenir.
   *
   * Neden: SdxCart.add `cart:added` olayını yayar; temanın hızlı-ekle modalı
   * (sdx-quick-add-modal.js) bu olayı dinleyip "Sepete eklendi" bildirimini açar.
   * Hediye için bu yanlış — müşteri bir şey eklememiştir, kampanya eklemiştir.
   * `SdxCart.get()` ile `cart:change` yine yayılır, yani sepet sayfası tazelenir.
   */
  function hediyeEkle(tier) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: tier.variantId,
        quantity: 1,
        properties: CFG.lineProperties
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('hediye eklenemedi: ' + res.status);
      return window.SdxCart.get();
    });
  }

  /** Sıralı sepet işlemleri; her adım bir öncekinin döndürdüğü sepetle devam eder. */
  function chain(ops, cart) {
    return ops.reduce(function (p, op) {
      return p.then(function (c) {
        return op(c).then(function (n) { return n && n.items ? n : c; }, function () { return c; });
      });
    }, Promise.resolve(cart));
  }

  function satirSil(line) {
    return function () { return window.SdxCart.change(line.key, 0); };
  }

  function reconcileTier(tier, cart) {
    // Sepete ekleme/çıkarma işini indirim app'i üstlenmişse tema karışmaz — iki taraf
    // da eklerse hediye ÇİFT eklenir. Panelden: "Hediyeyi tema sepete eklesin".
    if (!tier.autoAdd) return Promise.resolve(cart);

    var lines = linesOf(cart, tier.variantId);
    var total = eligibleTotal(cart);
    var qualified = tier.available && total >= tier.threshold;
    var qty = lines.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);

    // FAIL-SAFE — hediye satırı AZAMİ TUTARI aşarsa geri çek ve kademeyi sustur.
    // Eşik sıfır değil, çünkü ERP saşe SKU'sunu 0,01 TL tutuyor (2026-09-23 dersi).
    // Liquid tarafındaki FİYAT KAPISI ile AYNI değerdir — vaat ile teslimat tek kapı.
    var azami = typeof tier.maxGiftAmount === 'number' ? tier.maxGiftAmount : 100;
    var ucretli = lines.filter(function (i) { return (i.final_line_price || 0) > azami; });
    if (ucretli.length) {
      tier.available = false;
      return chain(ucretli.map(satirSil), cart);
    }

    if (qualified && qty === 0) {
      return hediyeEkle(tier).catch(function () {
        // Stok bitti / eklenemedi → bu kademe bir daha vaat etmez, denemez.
        tier.available = false;
        return cart;
      });
    }

    if (qualified && (qty > 1 || lines.length > 1)) {
      // Tam 1 adede indir: ilkini 1'e sabitle, fazlalık satırları sil.
      return chain(lines.map(function (line, idx) {
        return function () { return window.SdxCart.change(line.key, idx === 0 ? 1 : 0); };
      }), cart);
    }

    if (!qualified && lines.length) {
      return chain(lines.map(satirSil), cart);
    }

    return Promise.resolve(cart);
  }

  function reconcile(cart) {
    // Kapatılmış / fiyat kapısına takılmış kademenin sepette kalan hediyesi.
    var retiredLines = (cart.items || []).filter(function (i) { return RETIRED.indexOf(i.variant_id) !== -1; });
    var ops = retiredLines.map(satirSil);
    TIERS.forEach(function (tier) {
      ops.push(function (c) { return reconcileTier(tier, c); });
    });
    return chain(ops, cart);
  }

  /* ------------------------------------------------------------ durum değerlendirme */

  function tierState(tier, cart, total) {
    if (linesOf(cart, tier.variantId).length > 0 && total >= tier.threshold) return 'earned';
    if (tier.available && total >= tier.teaserMin && total < tier.threshold) return 'teaser';
    return 'idle';
  }

  /**
   * Sepet panelindeki (sdx-cart-drawer) mini ilerleme (`[data-sdx-gwp-mini]`). Sepet
   * şeridiyle (sdx-gwp-progress) aynı kurgu: metin = kazanılmamış en düşük kademenin
   * şerit metni, çubuk en yüksek kademenin eşiğine kadar dolar; hepsi kazanıldıysa en
   * yüksek kademenin "kazanıldı" metni. Şerit metni olmayan/kapalı kademe sayılmaz.
   */
  /**
   * Gösterilen kademeler (şerit metni olan, açık) ve sıradaki hedef: kazanılmamış en düşük
   * kademe. Mini ilerleme ile sepet panelinin buton/öneri kararı AYNI hesaptan beslenir.
   */
  function hedef(total) {
    var tiers = TIERS.filter(function (t) { return t.available && t.text && t.text.strip; });
    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      // Hediye satırı ekleme anında henüz sepette olmayabilir → karar tutardan.
      if (total < tiers[i].threshold) { next = tiers[i]; break; }
    }
    return { tiers: tiers, next: next, top: tiers.length ? tiers[tiers.length - 1] : null };
  }

  function renderMini(states, total) {
    var slot = document.querySelector('[data-sdx-gwp-mini]');
    if (!slot) return;
    var h = hedef(total);
    if (!h.tiers.length) { slot.hidden = true; return; }

    var top = h.top;
    var next = h.next;
    var focus = next || top;
    var text = next ? fill(focus, focus.text.strip, Math.max(0, focus.threshold - total))
                    : fill(focus, focus.text.stripWon || '', 0);
    if (!text) { slot.hidden = true; return; }

    var pct = next ? Math.max(0, Math.min(100, Math.round((total / top.threshold) * 100))) : 100;
    var img = focus.productImage ? '<img src="' + focus.productImage + '" alt="" width="28" height="28" loading="lazy">' : '';
    var p = document.createElement('p');
    p.className = 'sdx-cd__gift-text';
    p.innerHTML = img;
    p.appendChild(document.createTextNode(text));
    slot.innerHTML = '';
    slot.appendChild(p);
    if (next) {
      var track = document.createElement('div');
      track.className = 'sdx-cd__gift-track';
      track.setAttribute('role', 'progressbar');
      track.setAttribute('aria-valuemin', '0');
      track.setAttribute('aria-valuemax', '100');
      track.setAttribute('aria-valuenow', String(pct));
      track.innerHTML = '<span style="width:' + pct + '%"></span>';
      slot.appendChild(track);
    }
    slot.classList.toggle('is-won', !next);
    slot.hidden = false;
  }

  function evaluate(cart) {
    var total = eligibleTotal(cart);
    var states = TIERS.map(function (t) { return tierState(t, cart, total); });

    // Sepet şeridinin tutarlarını pop-up ile AYNI biçimlendiriciden tazele. Her slot
    // hangi kademeye ait olduğunu data-sdx-gwp-amount değerinde taşır.
    var slots = document.querySelectorAll('[data-sdx-gwp-amount]');
    for (var s = 0; s < slots.length; s++) {
      var th = parseInt(slots[s].getAttribute('data-sdx-gwp-amount'), 10);
      if (th > 0) slots[s].textContent = formatMoney(Math.max(0, th - total));
    }

    renderMini(states, total);

    // `next`: sepet paneli (sdx-cart-drawer.js) ana butonu ve önerileri buna göre seçer.
    var h = hedef(total);
    var nextRemaining = h.next ? Math.max(0, h.next.threshold - total) : 0;
    document.dispatchEvent(new CustomEvent('sdx:gwp-state', {
      detail: {
        total: total,
        next: h.next ? { name: urunAdi(h.next), remaining: nextRemaining, remainingText: formatMoney(nextRemaining) } : null,
        hasCampaign: h.tiers.length > 0,
        tiers: TIERS.map(function (t, i) {
          return { id: t.id, state: states[i], threshold: t.threshold, remaining: Math.max(0, t.threshold - total) };
        })
      }
    }));

    var popupAllowed = !DESIGN_MODE;
    var wonTier = null;
    var teaserTier = null;

    TIERS.forEach(function (tier, i) {
      var st = states[i];
      var prev = lastState[tier.id];
      lastState[tier.id] = st;
      if (!popupAllowed) return;
      if (!tier.siteWide && !document.querySelector('[data-sdx-cart-page]')) return;

      if (st === 'earned') {
        unmark(tier.id + '_teaser');
        if (tier.wonPopup && prev !== 'earned' && !seen(tier.id + '_won')) {
          mark(tier.id + '_won');
          wonTier = tier; // aynı anda birden çok kazanılırsa EN YÜKSEK kademe gösterilir
        }
      } else {
        unmark(tier.id + '_won');
        if (st === 'teaser' && prev !== 'teaser' && !seen(tier.id + '_teaser')) {
          mark(tier.id + '_teaser');
          if (!teaserTier) teaserTier = tier; // en yakın (en düşük) bekleyen kademe
        }
      }
    });

    // Tek seferde tek pop-up: kazanılan hediye teşvikten önce gelir.
    if (wonTier) sirayaGir(wonTier, 'won', 0);
    else if (teaserTier) sirayaGir(teaserTier, 'teaser', Math.max(0, teaserTier.threshold - total));
  }

  /* -------------------------------------------------------------------- pop-up */

  var overlay = null;
  var lastFocus = null;

  /**
   * Aynı anda iki modal açılmaz. Müşteri ürünü sepete eklediğinde temanın
   * "Sepete eklendi" dropdown'ı açılır; eşik o eklemeyle aşıldıysa bu pop-up onun
   * üstüne binerdi. Dropdown açıksa pop-up atlanır (bkz. sirayaGir).
   */
  function baskaModalAcik() {
    var cd = document.querySelector('.sdx-cd');
    return !!(cd && cd.classList.contains('is-open'));
  }

  /**
   * v3.8 (2026-10-26): "Sepete eklendi" artık kendiliğinden kapanmayan bir dropdown ve
   * hediye ilerlemesini KENDİSİ gösteriyor ([data-sdx-gwp-mini]). Eskiden pop-up dropdown
   * kapanana kadar ~16 sn bekleyip sonra üstüne açılıyordu (mobilde iki katman üst üste).
   * Dropdown açıkken pop-up ATLANIR; kademe çağrıdan önce mark() edildiği için sonra da
   * tekrar çıkmaz.
   */
  function sirayaGir(tier, kind, remaining) {
    if (baskaModalAcik()) return;
    openPopup(tier, kind, remaining);
  }

  function closePopup() {
    if (!overlay) return;
    overlay.setAttribute('hidden', '');
    document.documentElement.classList.remove('sdx-gwp-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* koptu */ } }
    lastFocus = null;
  }

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'sdx-gwp';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="sdx-gwp__scrim" data-sdx-gwp-close></div>' +
      '<div class="sdx-gwp__card" role="dialog" aria-modal="true" aria-labelledby="sdx-gwp-title" tabindex="-1">' +
        '<button type="button" class="sdx-gwp__close" data-sdx-gwp-close>' +
          '<span class="sdx-sr-only"></span>' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<div class="sdx-gwp__media"><img alt="" loading="lazy" width="150" height="150"></div>' +
        '<p class="sdx-gwp__badge"></p>' +
        '<h2 class="sdx-gwp__title" id="sdx-gwp-title"></h2>' +
        '<p class="sdx-gwp__body"></p>' +
        '<div class="sdx-gwp__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"><span></span></div>' +
        '<button type="button" class="sdx-btn sdx-btn--accent sdx-gwp__cta" data-sdx-gwp-close></button>' +
        '<p class="sdx-gwp__terms"></p>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-sdx-gwp-close]')) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && !overlay.hasAttribute('hidden')) closePopup();
    });
  }

  function openPopup(tier, kind, remaining) {
    if (!overlay) buildOverlay();
    var t = tier.text || {};
    var won = kind === 'won';
    var img = overlay.querySelector('.sdx-gwp__media img');
    var src = (won ? tier.productImage : (tier.popupImage || tier.productImage)) || '';

    if (src) { img.src = src; img.alt = tier.productTitle || ''; overlay.querySelector('.sdx-gwp__media').removeAttribute('hidden'); }
    else { overlay.querySelector('.sdx-gwp__media').setAttribute('hidden', ''); }

    var badge = overlay.querySelector('.sdx-gwp__badge');
    badge.textContent = won ? (t.badge || '') : (t.value || '');
    badge.toggleAttribute('hidden', !badge.textContent);

    overlay.querySelector('.sdx-gwp__title').textContent = fill(tier, won ? t.wonTitle : t.teaserTitle, remaining);
    overlay.querySelector('.sdx-gwp__body').textContent = fill(tier, won ? t.wonBody : t.teaserBody, remaining);

    var bar = overlay.querySelector('.sdx-gwp__bar');
    var pct = won ? 100 : Math.max(0, Math.min(100, Math.round(((tier.threshold - remaining) / tier.threshold) * 100)));
    bar.setAttribute('aria-valuenow', String(pct));
    bar.firstElementChild.style.width = pct + '%';
    bar.classList.toggle('is-complete', won);

    var cta = overlay.querySelector('.sdx-gwp__cta');
    cta.textContent = won ? (t.wonCta || t.teaserCta || '') : (t.teaserCta || '');
    cta.toggleAttribute('hidden', !cta.textContent);

    var terms = overlay.querySelector('.sdx-gwp__terms');
    terms.textContent = t.terms || '';
    terms.toggleAttribute('hidden', !terms.textContent);

    overlay.querySelector('.sdx-gwp__close .sdx-sr-only').textContent = CFG.close || '';
    overlay.classList.toggle('sdx-gwp--won', won);

    lastFocus = document.activeElement;
    overlay.removeAttribute('hidden');
    document.documentElement.classList.add('sdx-gwp-open');
    requestAnimationFrame(function () {
      var card = overlay.querySelector('.sdx-gwp__card');
      if (card) card.focus();
    });
  }

  /* ---------------------------------------------------------------- olay döngüsü */

  function run(cart) {
    if (busy) { pending = cart; return; }
    busy = true;
    reconcile(cart)
      .then(function (next) { evaluate(next && next.items ? next : cart); })
      .catch(function () { /* sepet API'si düştü — kampanya sessizce beklemede */ })
      .then(function () {
        busy = false;
        if (pending) { var p = pending; pending = null; schedule(p); }
      });
  }

  function schedule(cart) {
    if (!cart || !window.SdxCart) return;
    clearTimeout(timer);
    timer = setTimeout(function () { run(cart); }, 80);
  }

  document.addEventListener('cart:change', function (e) { schedule(e.detail && e.detail.cart); });
  document.addEventListener('cart:added', function (e) { schedule(e.detail && e.detail.cart); });

  /* ------------------------------------------------------- ödeme öncesi son kontrol */

  /**
   * #9292 (2026-10-27): sepete set eklenince (≈4.199 TL) matara eklendi, sonra 3 ürün
   * çıkarıldı ve hediye silinmeden ödemeye geçildi → 2.219 TL siparişe Cam Matara gitti.
   * İki açık: (1) ödeme butonu arka plandaki silmenin bitmesini beklemiyordu, (2) silme
   * isteği düşerse sessizce yutuluyordu. Non-Plus: kasada sunucu kontrolü YOK, son kapı
   * burası. Ödemeye geçişte sepet TAZE okunur; hak edilmeyen / fazla / ücretli hediye
   * varsa uzlaştırılıp yeniden okunur (en çok 3 deneme). Temizlenemezse geçiş durur.
   */
  function sepetOku() {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(base + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js ' + res.status);
        return res.json();
      });
  }

  function ihlalVar(cart) {
    var items = cart.items || [];
    if (items.some(function (i) { return RETIRED.indexOf(i.variant_id) !== -1; })) return true;
    var total = eligibleTotal(cart);
    return TIERS.some(function (tier) {
      if (!tier.autoAdd) return false;
      var lines = linesOf(cart, tier.variantId);
      if (!lines.length) return false;
      var azami = typeof tier.maxGiftAmount === 'number' ? tier.maxGiftAmount : 100;
      var qty = lines.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);
      var qualified = tier.available && total >= tier.threshold;
      return !qualified || qty > 1 ||
        lines.some(function (i) { return (i.final_line_price || 0) > azami; });
    });
  }

  function bekle(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function temizle(deneme) {
    return sepetOku().then(function (cart) {
      if (!ihlalVar(cart)) return true;
      if (deneme >= 3) return false;
      return reconcile(cart).then(function () { return bekle(300 * (deneme + 1)); })
        .then(function () { return temizle(deneme + 1); });
    }, function () {
      if (deneme >= 3) return false;
      return bekle(500 * (deneme + 1)).then(function () { return temizle(deneme + 1); });
    });
  }

  var geciyor = false;

  function kontrolluGec(tetik, devam) {
    if (tetik) { tetik.disabled = true; tetik.classList.add('is-loading'); }
    temizle(0).then(function (ok) {
      if (ok) { geciyor = true; devam(); return; }
      if (tetik) { tetik.disabled = false; tetik.classList.remove('is-loading'); }
      window.alert(CFG.checkoutRetry || '');
    });
  }

  // Sepet sayfası + sepet paneli: <button type="submit" name="checkout">.
  // Capture: başka submit dinleyicilerinden önce. Sepet sayfasının fatura doğrulaması
  // `click`'te çalışır (submit'ten önce), geçersizse submit hiç oluşmaz.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var sub = e.submitter || document.activeElement;
    if (geciyor || !sub || sub.name !== 'checkout' || !form || !form.contains(sub)) return;
    e.preventDefault();
    var formCls = (form.getAttribute('class') || '').trim().split(/\s+/).filter(Boolean);
    kontrolluGec(sub, function () {
      // Hediye silinince sepet paneli tazelenir ve formu YENİSİYLE değiştirir; kopmuş
      // formun submit()'i hiçbir şey yapmaz (testte ölçüldü). Güncel kopyayı bul.
      var hedef = form.isConnected ? form
        : (formCls.length ? document.querySelector('form.' + formCls.join('.')) : null);
      if (!hedef) {
        location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout';
        return;
      }
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = 'checkout';
      h.value = sub.value || '';
      hedef.appendChild(h);
      hedef.submit();
    });
  }, true);

  // Doğrudan /checkout bağlantıları.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (geciyor || !a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin || !/^\/checkouts?(\/|$)/.test(url.pathname)) return;
    e.preventDefault();
    kontrolluGec(null, function () { location.href = url.href; });
  }, true);
})();
